module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "used"
  }, [_c('div', {
    staticClass: "usedContent"
  }, [(_vm.couponsFn && _vm.couponsFn.length) ? _c('div', _vm._l((_vm.couponsFn), function(item, index) {
    return _c('xk-couponMod', {
      key: index,
      attrs: {
        "type": item.type,
        "sum": item.sum,
        "title": item.title,
        "startTime": item.startTime,
        "endTime": item.endTime,
        "overdueTime": item.overdueTime,
        "status": 1,
        "useState": 2,
        "couponType": item.couponType,
        "serviceType": item.serviceType
      }
    })
  }), 1) : _c('div', {
    staticClass: "jilv"
  }, [_c('h2', [_vm._v("暂无使用记录")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fac5dea0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mewallet/coupon/used.vue
// module id = 567
// module chunks = 0